import React, { Fragment, useState, useEffect, useRef } from "react";
import { Card, CardBody, Table, Row, Col, Button } from "reactstrap";
import _ from "lodash";
import Notifications from "../commons/Notifications";
import DefaultBenefitHit from "./Hit";
import DefaultBenefitForm from "./Form";

const DefaultBenefitsIndex = ({ defaultBenefits }) => {
  const [benefits, setBenefits] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing]     = useState(null);     // null → nuevo
  const n = useRef(null);

  useEffect(() => setBenefits(defaultBenefits || []), [defaultBenefits]);

  const notify = (t, m, tp) => n.current?.addNotifications(t, m, tp);

  const add    = b => setBenefits(v => [...v, b]);
  const up     = b => setBenefits(v => v.map(x => (x.id === b.id ? b : x)));
  const del    = id => setBenefits(v => v.filter(x => x.id !== id));

  const openNew  = () => { setEditing(null);  setModalOpen(true); };
  const openEdit = b  => { setEditing(b);     setModalOpen(true); };
  const close    = () => { setModalOpen(false); setEditing(null); };

  return (
    <Fragment>
      <Notifications ref={n} />

      <Card className="mb-4 material-shadow">
        <CardBody className="bg-light">
          <Row className="align-items-center">
            <Col md="8">
              <h3 className="h4 mb-0">Beneficios por Defecto</h3>
              <p className="small text-muted mb-0">
                Mantén aquí los beneficios reutilizables para las publicaciones.
              </p>
            </Col>
            <Col md="4" className="text-end">
              <Button color="success" style={{ color: "white" }} onClick={openNew}>
                Nuevo Beneficio
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card className="material-shadow">
        <CardBody>
          <Table responsive>
            <thead>
            <tr>
              <th>#</th><th>Título / Contenido</th><th>Estado</th><th>Acciones</th>
            </tr>
            </thead>
            <tbody>
            {benefits.map((b,i)=>(
              <DefaultBenefitHit
                key={b.id}
                index={i+1}
                benefit={b}
                onEdit={openEdit}
                onDeleteLocal={del}
                onUpdateLocal={up}
                notify={notify}
              />
            ))}
            {benefits.length===0 && (
              <tr><td colSpan="4" className="text-center text-muted">Sin beneficios</td></tr>
            )}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      {modalOpen && (
        <DefaultBenefitForm
          isOpen={modalOpen}
          onClose={close}
          benefit={editing}
          notify={notify}
          afterCreate={add}
          afterUpdate={up}
        />
      )}
    </Fragment>
  );
};
export default DefaultBenefitsIndex;
